/** PURE_IMPORTS_START ._BoundNodeCallbackObservable PURE_IMPORTS_END */
import { BoundNodeCallbackObservable } from './BoundNodeCallbackObservable';
export var bindNodeCallback = BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/bindNodeCallback.js
// module id = ./node_modules/rxjs/_esm5/observable/bindNodeCallback.js
// module chunks = vendor